"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var OptionGroup = function OptionGroup(props) {
  var onClickCategory = function onClickCategory(event, value, label) {
    if (!props.isDisabled) {
      props.onSelect({
        label: label,
        value: value,
        category: true
      }, event);
    }
  };
  var option = props.option,
    isSelected = props.isSelected,
    isDisabled = props.isDisabled;
  var className = (0, _classnames["default"])(props.className, option.className);
  var groupClassNames = (0, _classnames["default"])('Select-option-group-label', {
    'is-selected': isSelected,
    'is-disabled': isDisabled
  });

  // if (option.disabled) {
  //   return <div className={className}>{props.children}</div>;
  // }

  return /*#__PURE__*/React.createElement("div", {
    className: className,
    style: option.style,
    title: option.title
  }, /*#__PURE__*/React.createElement("div", {
    className: groupClassNames,
    onClick: function onClick(event) {
      return onClickCategory(event, option.value, option.label);
    }
  }, props.label), props.children);
};
var _default = exports["default"] = OptionGroup;